import { useEffect } from 'react';

import { useGetFundingRequestLazyQueryGQLType } from '../../../../types/dashboard-core-gqlTypes.generated.d';
import { PermissionsFn, usePermissionGuard } from '~/core/PermissionGuard';

export const duplicatePermissions: PermissionsFn = (context) => {
  if (context.user.userType === 'CAPITAL_PROVIDER') {
    return context.flags.productsFundingRequestsLenderDuplicatePermissions;
  }
  return context.flags.productsFundingRequestsDuplicatePermissions;
};

export const useCanResubmitFundingRequest = ({
  fundingRequestId,
}: {
  fundingRequestId: string;
}) => {
  const duplicatePermission = usePermissionGuard(duplicatePermissions);
  const [
    getFundingRequest,
    { data, loading: isLoading },
  ] = useGetFundingRequestLazyQueryGQLType({
    fetchPolicy: 'network-only',
  });

  useEffect(() => {
    if (fundingRequestId) {
      getFundingRequest({
        variables: {
          fundingRequestId,
        },
      });
    }
  }, [fundingRequestId, getFundingRequest]);

  return isLoading || !data
    ? {
        status: 'loading',
        canDuplicate: false,
      }
    : {
        status: 'ready',
        canDuplicate:
          data?.fundingRequestWithFullDetails.status === 'submitted' &&
          duplicatePermission === 'allow',
      };
};
